/**
 * @generated SignedSource<<c5b46674660ef656d0566b15d8b1c26c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BrainSearchRelatedQuestionListQuery$variables = {
  id: string;
};
export type BrainSearchRelatedQuestionListQuery$data = {
  readonly node: {
    readonly __typename: string;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"BrainSearchRelatedQuestionListFragment">;
  } | null;
};
export type BrainSearchRelatedQuestionListQuery = {
  response: BrainSearchRelatedQuestionListQuery$data;
  variables: BrainSearchRelatedQuestionListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BrainSearchRelatedQuestionListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BrainSearchRelatedQuestionListFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BrainSearchRelatedQuestionListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 3
                  }
                ],
                "concreteType": "BrainSearchRelatedQuestionNodeConnection",
                "kind": "LinkedField",
                "name": "brainSearchRelatedQuestions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BrainSearchRelatedQuestionNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BrainSearchRelatedQuestion",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "text",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "brainSearchRelatedQuestions(first:3)"
              }
            ],
            "type": "BrainSearchMessage",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0880625b1ce3b646bcbf25a140f8905c",
    "id": null,
    "metadata": {},
    "name": "BrainSearchRelatedQuestionListQuery",
    "operationKind": "query",
    "text": "query BrainSearchRelatedQuestionListQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    id\n    ...BrainSearchRelatedQuestionListFragment\n  }\n}\n\nfragment BrainSearchRelatedQuestionListFragment on BrainSearchMessage {\n  id\n  brainSearchRelatedQuestions(first: 3) {\n    totalCount\n    edges {\n      node {\n        id\n        text\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f399b8258fa51ff39c34f584a405d7f0";

export default node;
